import PropTypes from "prop-types";
import "./RangeProgressBar.scss";

const RangeProgressBar = ({
  min,
  max,
  step,
  value,
  onChange,
  options,
  id,
  readOnly = false,
}) => {
  const handleChange = (e) => {
    if (readOnly) return;

    onChange(Number(e.target.value));
  };

  const handleStepMarkerClick = (val) => {
    if (readOnly) return;

    onChange(val);
  };
  const percentage = ((value - min) / (max - min)) * 100;
  return (
    <div className="range-bar" style={{ "--value": `${percentage}%` }} id={id}>
      <input
        id={id}
        type="range"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={handleChange}
        list="tickmarks"
        className="range-input"
        disabled={readOnly}
      />
      <div className="step-markers" id={id}>
        {options.values.map((option, index) => (
          <div
            id={id}
            key={index}
            className={`step-marker ${value >= option.val ? "active" : ""} ${
              option.original === true && value == option.val ? "original-selected" : ""
            } ${
              option.original === true && value > option.val
                ? "original"
                : ""
            }${
              option.original === true && value < option.val ? "original" : ""
            }`}
            onClick={
              readOnly ? undefined : () => handleStepMarkerClick(option.val)
            }
          ></div>
        ))}
      </div>
      <datalist id="tickmarks">
        {options.values.map((option, index) => (
          <option key={index} value={index} label={option.lb}></option>
        ))}
      </datalist>
      <div className="labels">
        {options.values.map((option, index) => (
          <div
            key={index + 1}
            className={`label ${value == option.val ? "active" : ""}`}
            style={{ width: `${100 / options.length}%` }}
          >
            {option.lb}
          </div>
        ))}
      </div>
    </div>
  );
};

RangeProgressBar.propTypes = {
  id: PropTypes.string.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  step: PropTypes.number,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      val: PropTypes.number.isRequired,
      lb: PropTypes.string.isRequired,
    })
  ).isRequired,
};

RangeProgressBar.defaultProps = {
  step: 1,
};

export default RangeProgressBar;
